import React, { PureComponent } from 'react';

import { Breadcrumbs } from '@eventbrite/eds-breadcrumbs';
import { PROP_TYPES_CRUMBS } from '../constants/componentPropTypes';

const DEFAULT_CLASSNAMES = 'eds-l-pad-left-6 eds-l-pad-top-5';

export default class HeaderBreadcrumbs extends PureComponent {
    static propTypes = {
        crumbs: PROP_TYPES_CRUMBS,
    };

    render() {
        const { crumbs } = this.props;

        return (
            <div className={DEFAULT_CLASSNAMES}>
                <Breadcrumbs crumbs={crumbs} />
            </div>
        );
    }
}
